export default {
  headerTitle: 'Employers',
  multipleEmployeesType: 'Multiple-employees',
};
